import { ROUTES } from "../Routes/Routes";

/**
 * @param {Record<string, unknown>|null|undefined} card
 * @returns {Record<string, unknown>|null}
 */
export function getPackageProfileFullDealFromChatCard(card) {
  const fd = card?.package_profile_full_deal;
  if (!fd || typeof fd !== "object") return null;
  if (fd.dealId != null || fd.id != null) return fd;
  const lid = card?.lds_deal_id;
  if (lid != null && String(lid).trim()) {
    return { ...fd, dealId: String(lid).trim() };
  }
  return fd;
}

/**
 * מעדכן את ה־context (selectedResult) לחבילה מהכרטיס — בלי ניווט. לשימוש בתוך צ'אט.
 * @returns {boolean}
 */
export function selectPackageDealForChatContext(card, setSelectedResult_resetAllFields) {
  const fullDeal = getPackageProfileFullDealFromChatCard(card);
  if (!fullDeal) return false;
  const ok = fullDeal.dealId != null || fullDeal.id != null;
  if (!ok) return false;
  setSelectedResult_resetAllFields(fullDeal);
  return true;
}

/**
 * מסך מלא: אותו context + מעבר ל־/packages/profile
 * @returns {boolean}
 */
export function navigateToFullPackageProfile(navigate, card, setSelectedResult_resetAllFields) {
  if (!selectPackageDealForChatContext(card, setSelectedResult_resetAllFields)) return false;
  navigate(`/${ROUTES.PACKAGE_PROFILE}`);
  return true;
}

/**
 * פותח את עמוד פרטי החבילה (UnsavedPackagesProfile) עם אותו מבנה כמו בחיפוש הסוכן.
 * @returns {boolean} true אם בוצע ניווט
 */
export function openCustomerChatPackageProfile(card, navigate, setSelectedResult_resetAllFields) {
  return navigateToFullPackageProfile(navigate, card, setSelectedResult_resetAllFields);
}
